import { useActivity } from 'modules/core/lib/activities/activity'
import type { ActivityComponent } from 'modules/core/lib/activities/types'

import CreateTaskFormModal from 'modules/procurement/components/taskForms/CreateTaskFormModal'

export const CreateTaskFormActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return <CreateTaskFormModal onClose={closeActivity} />
}
